/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {useEffect, useState} from 'react'
import {Link, useNavigate} from 'react-router-dom'
import {KTSVG} from '../../../_metronic/helpers'
import {useDispatch, useSelector} from 'react-redux'
import useUtils from './useUtils'
import {setTitle} from '../../redux/reducers/mainSlice'
import EditCategory from './EditCategory'
import Pagination from '../../modules/pagination/Pagination'
import DeleteConfirmation from '../../modules/alert/DeleteConfirmation'
import TableSkeleton from '../../modules/skeleton/TableSkelton'
import {showAlert} from '../../redux/reducers/alertSlice'
import AssignConfirmation from '../../modules/alert/AssignConfirmation'

const CategoryList = ({className}) => {
  const [show, setShow] = useState(false)
  const [loading, setLoading] = useState(false)

  const dispatch = useDispatch()
  dispatch(setTitle('Category'))

  const {fetchCategories, deleteCategory, makeDefault} = useUtils()
  const [name, setName] = useState()
  const [editable, setEditable] = useState({})
  const [categories, setCategories] = useState([])
  const [type, setType] = useState('')
  const [page, setPage] = useState(1)
  const [limit, setLimit] = useState(10)
  const [totalPages, setTotalPages] = useState(1)

  const [modalVisible, setModalVisible] = useState(false)
  const [selectedId, setSelectedId] = useState(null)
  const [assignVisible, setAssignVisible] = useState(false)
  const [selectedCategory, setSelectedCategory] = useState(null)
  const handleEdit = (values) => {
    setShow(true)
    setType('edit')
    setEditable(values)
  }

  const handleAssign = async (values) => {
    if (values?.isDefault) {
      dispatch(
        showAlert({
          message: `${values?.name} is already default category`,
          variant: 'info',
          timeout: '1500',
        })
      )
      return
    } else {
      setSelectedCategory(values)
      setAssignVisible(true)
    }
  }

  const confirmAssign = async () => {
    if (!selectedCategory) return
    try {
      setLoading(true)
      const result = await makeDefault(selectedCategory, limit, (page - 1) * limit)
      setCategories(result)
    } catch (error) {
      console.error('Error assigning category:', error)
    } finally {
      setLoading(false)
      setAssignVisible(false)
      setSelectedCategory(null)
    }
  }


  const handleDelete = (value) => {
    if (value?.isDefault) {
      dispatch(
        showAlert({
          message: `Default category cannot be deleted`,
          variant: 'danger',
          timeout: '1500',
        })
      )
    } else {
      setSelectedId(value?.id)
      setModalVisible(true)
    }
  }

  const confirmDelete = async () => {
    if (!selectedId) return
    try {
      setLoading(true)
      const result = await deleteCategory(selectedId, limit, (page - 1) * limit)
      setCategories(result)
    } catch (error) {
      console.error('Error deleting category:', error)
    } finally {
      setLoading(false)
      setModalVisible(false)
      setSelectedId(null)
    }
  }

  const getCategories = async () => {
    try {
      setLoading(true)
      const offset = (page - 1) * limit
      const result = await fetchCategories(limit, offset)
      setTotalPages(Math.ceil(result?.count / limit))
      setCategories(result)
    } catch (error) {
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    getCategories()
  }, [limit, page])

  if (loading) return <TableSkeleton />
  return (
    <>
      {/* begin::Header */}

      <div className={`card ${className}`}>
        <div className='card-body py-3'>
          <div className='table-responsive'>
            <div className='card-header border-0 pt-5'>
              <div className='d-flex align-items-center'>
                <h3 className=' align-items-start flex-column'>
                  <span className=' mt-1 text-muted fs-7 '>{categories?.count} Items</span>
                </h3>
              </div>
              <div className='card-toolbar'>
                <a
                onClick={() => {
                  setShow(true)
                  setType('add')
                }}
                  className='btn btn-sm btn-light-primary'
                >
                  <KTSVG path='/media/icons/duotune/arrows/arr075.svg' className='svg-icon-2' />
                  Add Category
                </a>
              </div>
            </div>

            {categories?.count === 0 && (
              <div className='mt-20 mb-20 w-sm-100 w-md-75 mx-auto p-5 py-20'>
                <div className='card-body text-center'>
                  <span className='svg-icon svg-icon-2hx svg-icon-info mb-5'>
                    <KTSVG path='/media/icons/duotune/general/gen044.svg' className='svg-icon-2x' />
                  </span>
                  <h4 className='mb-1'>No Records Found</h4>
                  <span>Add more Categories</span>
                </div>
              </div>
            )}

            {categories?.count > 0 && (
              <div className='d-flex card-header'>
                <table className='table table-row-bordered table-row-gray-100 align-middle gs-0 gy-3'>
                  <thead>
                    <tr className='fw-bold text-muted'>
                      <th className='min-w-100px'>ID</th>
                      <th className='min-w-100px'>Name</th>
                      <th className='min-w-100px text-end'>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {categories?.records &&
                      categories?.records?.map((value, index) => {
                        return (
                          <tr key={index}>
                            <td className='text-nowrap'>
                              <a href='#' className='text-dark fw-bold fs-6'>
                                {value.id}
                              </a>
                            </td>
                            <td>
                              <a href='#' className='text-dark fw-bold  fs-6'>
                                {`${value.name} ${value?.isDefault ? '(default)' : ''}`}
                              </a>
                            </td>
                            <td className='text-end'>
                              <a
                                onClick={() => handleEdit(value)}
                                className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                              >
                                <KTSVG
                                  path='/media/icons/duotune/art/art005.svg'
                                  className='svg-icon-3 svg-icon-primary'
                                />
                              </a>
                              <a
                                onClick={() => handleAssign(value)}
                                className='btn btn-icon btn-bg-light  btn-sm me-1'
                              >
                                <KTSVG
                                  path='/media/icons/duotune/general/gen048.svg'
                                  className={`svg-icon-3 ${
                                    value?.isDefault ? 'svg-icon-primary' : ''
                                  }`}
                                />
                              </a>
                              <a
                                onClick={() => handleDelete(value)}
                                className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm'
                              >
                                <KTSVG
                                  path='/media/icons/duotune/general/gen027.svg'
                                  className='svg-icon-3 text-danger'
                                />
                              </a>
                            </td>
                          </tr>
                        )
                      })}
                  </tbody>
                </table>
              </div>
            )}
          </div>
        </div>
        <div className='d-flex align-items-center justify-content-between pb-5 ps-10 pe-5'>
          <div className='d-flex align-items-center gap-3'>
            <span className='fs-6 text-muted'>Show</span>
            <div>
              <select
                defaultValue={limit}
                className='form-select form-select-solid text-muted select2-hidden-accessible'
                onChange={(e) => {
                  setPage(1)
                  setLimit(e.target.value)
                }}
              >
                <option>10</option>
                <option>20</option>
                <option>50</option>
                <option>100</option>
              </select>
            </div>
          </div>
          <DeleteConfirmation
            isVisible={modalVisible}
            message='Are you sure you want to delete Category?'
            onConfirm={confirmDelete}
            onCancel={() => setModalVisible(false)}
          />
          <AssignConfirmation
            isVisible={assignVisible}
            message='Are you sure you want to change default Category?'
            onConfirm={confirmAssign}
            onCancel={() => setAssignVisible(false)}
          />
          <Pagination currentPage={page} totalPages={totalPages} onPageChange={setPage} />
        </div>
      </div>

      <EditCategory
        show={show}
        handleClose={() => setShow(false)}
        category={editable}
        limit={limit}
        offset={(page - 1) * limit}
        setCategories={setCategories}
        type={type}
        setType={setType}
      />
      {/* begin::Body */}
    </>
  )
}

export default CategoryList
